import type { BillingInvoiceViewModel } from '@cognitoforms/types/server-types/services/view-models/billing-invoice-view-model';
import { InvoiceStatus } from '@cognitoforms/types/server-types/plans/model/invoice-status';
import { InvoiceCategory } from '@cognitoforms/types/server-types/plans/model/invoice-category';
import { SubInvoiceType } from '@cognitoforms/types/server-types/plans/model/sub-invoice-type';

export function isOpenPayableInvoice(invoice: BillingInvoiceViewModel, isAnnual: boolean | null | undefined): boolean {
	return invoice.Status === InvoiceStatus.Open
		&& invoice.SubType !== SubInvoiceType.AnnualPrepaymentRenewal
		&& (isAnnual !== true || invoice.Category === InvoiceCategory.Prepayment);
}
